import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { CONTACT } from "@/i18n";

const SettingsContext = createContext(null);
const DEFAULT = { contacts: CONTACT, payment_methods: [], default_exchange_rate: 20500 };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULT, ...data, contacts: { ...CONTACT, ...(data.contacts || {}) } });
    } catch {}
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <SettingsContext.Provider value={{ settings, reload }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
